
<div class="w-full flex flex-row justify-center my-12 font-rubik">
  <div class="w-full max-w-1012 mx-5 flex flex-col lg:flex-row gap-6 lg:gap-0">
    <div class="w-full flex flex-rows gap-2 lg:gap-0">
      <div class="w-full flex justify-start lg:justify-center">
        <div class="w-full lg:w-2/3 text-start lg:text-center">
          <h1 class="statistics-h1">2008</h1>
          <p>Founded</p>
        </div>
      </div>
      <div class="w-full">
        <div class="w-full flex justify-start lg:justify-center">
          <div class="w-full lg:w-2/3 text-start lg:text-center">
            <h1 class="statistics-h1">$20m</h1>
            <p>Product Sales</p>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex flex-rows gap-2 lg:gap-0">
      <div class="w-full flex justify-start lg:justify-center">
        <div class="w-full lg:w-2/3 text-start lg:text-center">
          <h1 class="statistics-h1">50</h1>
          <p>States being served</p>
        </div>
      </div>
      <div class="w-full">
        <div class="w-full flex justify-start lg:justify-center">
          <div class="w-full lg:w-2/3 text-start lg:text-center">
            <h1 class="statistics-h1">5k+</h1>
            <p>Customers</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
